var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preload-component",attrs:{"id":"preload"}},[_c('div',{attrs:{"id":"loading"}},[_vm._v(" Loading... "+_vm._s(Math.round( ((_vm.percentCompletedImages + _vm.percentCompletedAudio) / 2) * 100 ))+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }